export const DEFAULT_FILTER = {
  isActive: 'true',
};

const userState = {
  isUsersUpdating: false,
  downloadedUser: {},
  viewMode: null,
};

export default userState;
